module.exports = __webpack_public_path__ + "img/L_3H.3445b0e0.png";